import { Pagination, SelectedFilter, NormalisedResponse } from "../types";
import { getProductsFromSectionRenderingAPI } from "./section-rendering";
import { getProductsFromStorefrontAPI } from "./storefront";
import { getProductsFromKlevuAPI } from "./klevu";

type ApiString = "SECTION_RENDERING" | "STOREFRONT" | "BOOST" | "KLEVU";

const API: ApiString = "SECTION_RENDERING";

export const getProducts = async (
  api: ApiString = API,
  selectedFilters: SelectedFilter[],
  pagination: Pagination,

  selectedSort: string = "best-selling",
): Promise<NormalisedResponse> => {
  switch (api) {
    case "SECTION_RENDERING":
      return getProductsFromSectionRenderingAPI(
        selectedFilters,
        selectedSort,
        pagination,
      );
    case "STOREFRONT":
      return getProductsFromStorefrontAPI();
    case "BOOST":
    case "KLEVU":
      return getProductsFromKlevuAPI();
  }
};
